import { render, staticRenderFns } from "./PrivacyPopup.vue?vue&type=template&id=7e8e0b0c&scoped=true&"
import script from "./PrivacyPopup.vue?vue&type=script&lang=js&"
export * from "./PrivacyPopup.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPopup.vue?vue&type=style&index=0&id=7e8e0b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e0b0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e8e0b0c')) {
      api.createRecord('7e8e0b0c', component.options)
    } else {
      api.reload('7e8e0b0c', component.options)
    }
    module.hot.accept("./PrivacyPopup.vue?vue&type=template&id=7e8e0b0c&scoped=true&", function () {
      api.rerender('7e8e0b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/PrivacyPopup.vue"
export default component.exports